export const PRODUCT_NAME_PATTERN = /^[A-Za-z0-9_-]{2,50}$/;
export const PRODUCT_BRAND_PATTERN = /^(?! )[A-Za-z0-9 _\-.]{2,90}(?<! )$/;
export const PRODUCT_UPC_PATTERN = /^\d{12}$/;
export const PRODUCT_PRICE = /^\d+(\.\d{1,2})?$/;
export const PRODUCT_DESCRIPTION_PATTERN =
  /^(?!\s)(?!.*<\/?[^>]+>)[A-Za-z0-9\s.,!?'"()\-_:;@#%&*/+=[\]{}<>|\\^~`$]{1,500}(?<!\s)$/;
